import React, { forwardRef, useImperativeHandle, useState } from 'react';
import { Grid, Typography, Button } from '@mui/material';
import * as pdfjsLib from "pdfjs-dist";
import { useDataAuth } from '../../hooks/useDataAuth';
import { upLoadPDF } from '../../services/proveedor.service';
import { useTranslation } from 'react-i18next';


export const AttachmentsForm = forwardRef(({ data = {}, onChange }, ref) => {
    const { t } = useTranslation();
    const [formData, setFormData] = useState(data);
    const [attachments, setAttachments] = useState({});
    const [{ userSession }] = useDataAuth();

    const handleChange = (field, value) => {
        const updatedData = {
            ...formData,
            [field]: value,
        };
        setFormData(updatedData);

        if (onChange) {
            onChange(field, value);
        }
    };

    const handleFileChange = async (field, event) => {
        const file = event.target.files[0];
        if (!file || file.type !== "application/pdf") {
            console.error("Solo se permiten archivos PDF.");
            return;
        }
        // console.log("Archivo seleccionado para", field, file);
        handleChange(field, file);
        const imagesBase64 = await extractImagesFromPDF(file);
        setAttachments(prev => ({ ...prev, [field]: imagesBase64 }));

        const data = {
            "id_flow": "900114098-GET_INFORMATION_RUT",
            "id": 12345,
            "name": file.name,
            "file": imagesBase64[0]
        }
        console.log("data ", data)
        try {
            const response = await upLoadPDF(userSession.token, data);
            console.log("response1 ", response)

            if (response.data && response.status === 200) {
                setTimeout(async () => {
                    const newData = {
                        "id_flow": "900114098-GET_RESPONSE_INFORMATION_RUT",
                        "id_unique": response.data.id_unique
                    }
                    console.log("Nuevos datos ", newData);

                    try {
                        const newResponse = await upLoadPDF(userSession.token, newData);
                        console.log("Nueva respuesta ", newResponse);
                    } catch (e) {
                        console.log(e);
                    }
                }, 30000);
            }
        } catch (e) {
            console.log(e)
        }
    };


    const extractImagesFromPDF = async (file) => {
        const fileReader = new FileReader();
        return new Promise((resolve, reject) => {
            fileReader.onload = async () => {
                try {
                    const pdfData = new Uint8Array(fileReader.result);
                    const pdf = await pdfjsLib.getDocument(pdfData).promise;
                    const totalPages = pdf.numPages;
                    const images = [];

                    const canvas = document.createElement("canvas");
                    const context = canvas.getContext("2d");

                    for (let i = 1; i <= totalPages; i++) {
                        const page = await pdf.getPage(i);
                        const viewport = page.getViewport({ scale: 1.5 });
                        canvas.width = viewport.width;
                        canvas.height = viewport.height;
                        await page.render({ canvasContext: context, viewport }).promise;
                        // images.push(canvas.toDataURL("image/png"));
                        const base64Image = canvas.toDataURL("image/png").split(",")[1];
                        images.push(base64Image);
                    }
                    console.log("images ", images)
                    resolve(images);
                } catch (error) {
                    console.error("Error al extraer imágenes del PDF", error);
                    reject(error);
                }
            };
            fileReader.readAsArrayBuffer(file);
        });
    };

    useImperativeHandle(ref, () => ({
        getData: () => ({
            ...formData,
            attachments,
        }),
    }));

    return (
        <>
            <Grid container spacing={2} sx={{ mt: 2 }}>
                <Grid size={{ xs: 12}}>
                    <Typography variant="h6">{t('common.attachments')}</Typography>
                </Grid>

                {[
                    { label: t('suppliers.uploadTaxCertificate'), field: "rut" },
                    { label: t("suppliers.uploadBankCertificate"), field: "certificacionBancaria" },
                    { label: t("suppliers.uploadIncorporationCertificateOptional"), field: "certificadoConstitucion" },
                ].map(({ label, field }) => (
                    <Grid size={{ xs:4, sm:4 }} key={field}>
                        <Button variant="contained" component="label" sx={{
                            width: '100%', height: '50px', borderRadius: '8px', textTransform: 'none',
                        }}>
                            {label}
                            <input type="file" hidden onChange={(e) => handleFileChange(field, e)} />
                        </Button>
                    </Grid>
                ))}
            </Grid>
        </>
    )
});